import Vue from "vue";
import { DateTime } from "luxon";
import store from "@/store/index";

const SYS_DATEFORMAT = {
    MMDDYYYY: "MM/DD/YYYY",
    DDMMYYYY: "DD/MM/YYYY",
    YYYYMMDD: "YYYY/MM/DD",
    MDDYYYY: "M DD, YYYY",
    DDMYYYY: "DD M YYYY",
    DD_M_YYYY: "DD-M-YYYY"
};

function getLuxonFormat(format) {
    let oFmt = format ? format : store.state.setting.date_format;

    switch (oFmt) {
        case SYS_DATEFORMAT.MMDDYYYY:
            return "MM/dd/yyyy";
        case SYS_DATEFORMAT.DDMMYYYY:
            return "dd/MM/yyyy";
        case SYS_DATEFORMAT.YYYYMMDD:
            return "yyyy/LL/dd";
        case SYS_DATEFORMAT.MDDYYYY:
            return "MMM dd, yyyy";
        case SYS_DATEFORMAT.DDMYYYY:
            return "dd MMM yyyy";
        case SYS_DATEFORMAT.DD_M_YYYY:
            return "dd-MMM-yyyy";
        default:
            return "MMM dd, yyyy";
    }
}

Vue.filter("secondsToDate", function (value) {
    if (!value) return "";
    let date_format = store.state.setting.date_format;
    let date = DateTime.fromSeconds(value);
    let format = date_format ? date_format : "DD-MMM-YYYY";
    format = getLuxonFormat(format);

    return DateTime.fromISO(date).toFormat(format);
});

Vue.filter("toDateTime", function (value, timezone) {
    if (!value) return "";
    let time = DateTime.fromISO(value).setZone(timezone);
    return time.toFormat("dd/LL/yyyy hh:mm a");
});

Vue.filter("isoDateToSeconds", function (value) {
    if (!value) return "";

    return DateTime.fromISO(value).toFormat("X");
});

Vue.filter("toDateTimeMyFormat", function (value, timezone) {
    if (!value) return "";
    var date_format = store.state.setting.date_format;
    var format = date_format ? date_format : "DD-MMM-YYYY";
    format = getLuxonFormat(format);

    let dateTime = DateTime.fromISO(value).setZone(timezone);
    return dateTime.toFormat(format);
});

Vue.filter("valid_uuid", function (value) {
    var valid = false;
    if (value != null && value.length > 0) {
        var val2 = value.replace(/0/g, "");
        if (val2.trim() !== "") {
            valid = true;
        }
    }
    return valid;
});

Vue.filter("toCurrency", function (value) {
    if (!value) return "";

    let val = Number(val);
    val = (value / 1).toFixed(2);

    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
});
